import React, { useMemo } from 'react';
import classNames from 'classnames';

import styles from './QuestionResponse.module.scss';

function BaseQuestionResponse({ question, children }) {
  const className = useMemo(
    () =>
      classNames(
        styles['question-review-response'],
        'question-review-response',
        'question-results-wrapper'
      ),
    []
  );

  return (
    <div className={className}>
      <div className="question-review-question-text">{question.text}</div>
      <div className="question-review-response-body">{children}</div>
    </div>
  );
}

export default BaseQuestionResponse;
